export default "__VITE_ASSET__i1nwd1e4__"